import {IValidatorField} from '@pluto-tv/assemble';
import {IUser} from 'models/users';

export const allowedEmailDomains = ['pluto.tv', 'paramount.com', 'skydance.com'];

export const userValidator: IValidatorField<IUser>[] = [
  {
    name: 'displayName',
    label: 'Full Name',
    required: true,
    validators: [
      (name: string): string | undefined => {
        if (!name || !name.trim().length) {
          return 'Name is required';
        } else if (name && name.trim().length > 100) {
          return 'Name must be less than 100 characters';
        }
      },
    ],
  },
  {
    name: 'email',
    label: 'Email',
    validators: [
      (email: string): string | undefined => {
        if (!email || !email.trim().length) {
          return 'Email is required';
        } else if (email && !/^[A-Z0-9_%+-]+(\.[A-Z0-9_%+-]+)*@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email.trim())) {
          return 'Invalid email address';
        } else if (email && !allowedEmailDomains.some(domain => email.trim().toLowerCase().endsWith(`@${domain}`))) {
          return `Email domain must be one of the following: ${allowedEmailDomains.join(', ')}`;
        }
      },
    ],
  },
  {
    name: 'active',
  },
  {
    name: 'roles',
    label: 'Role',
  },
  {
    name: 'regions',
    label: 'Region(s)',
  },
];
